// @flow weak

/* eslint consistent-return: 0 */
import React      from 'react';
import PropTypes  from 'prop-types';

const Breadcrumb = ({
  path,links,context
}) => (
  <ul className="breadcrumb">
  {
    path.length === 0 &&
    <div></div>
  }
  {
    path.length > 0 &&
    path.map(
      (view, viewIndex) => {
        if (viewIndex === 0) {
          return (
            <li key={viewIndex}>
              <a href onClick={(e) => {
                e.preventDefault()
                context.router.history.push('/dashboard')
              }}>
                
                  &nbsp;
                  {view}
              </a>
            </li>
          );
        }
        if (viewIndex < path.length - 1) {
          return (
            <li
              key={viewIndex}
              className="active">
              <a href onClick={(e) => {
                e.preventDefault()
                context.router.history.push(`/${links[viewIndex]}`)
              }} >
               {view}
              </a>
            </li>
          );
        }
        if (viewIndex === path.length - 1) {
          return (
            <li key={viewIndex}
              className="active">
              <a href onClick={(e) => {
                e.preventDefault()
                context.router.history.push(`/${links[viewIndex]}`)
              }} >
                {view}
              </a>
            </li>
          );
        }
      }
    )
  }
  </ul>
);

Breadcrumb.propTypes = {
  path: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  links: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  context: PropTypes.object
};

export default Breadcrumb;


// WEBPACK FOOTER //
// ./src/app/components/breadcrumb/NewBreadcrumb.js